export const LOG_APPROVAL_REQUEST = "LOG_APPROVAL_REQUEST";
export const LOG_APPROVAL_SUCCESS = "LOG_APPROVAL_SUCCESS";
export const LOG_APPROVAL_FAILED = "LOG_APPROVAL_FAILED";
